import { SiteBackgroundGradient } from '@hostinger/builder-schema-validator/schema/schemaTypes';

export const extractGradientStops = (value: string): string[] => {
	const stops: string[] = [];

	const start = value.indexOf('(');
	const end = value.lastIndexOf(')');

	if (start === -1 || end === -1) return stops;

	const inner = value.slice(start + 1, end).trim();

	let depth = 0;
	const firstCommaIndex = [...inner].findIndex((char) => {
		if (char === '(') depth += 1;
		else if (char === ')') depth -= 1;

		return char === ',' && depth === 0;
	});

	if (firstCommaIndex === -1) return stops;

	const stopsString = inner.slice(firstCommaIndex + 1).trim();

	let current = '';

	depth = 0;

	[...stopsString].forEach((char) => {
		if (char === '(') depth += 1;
		else if (char === ')') depth -= 1;

		if (char === ',' && depth === 0) {
			if (current.trim()) stops.push(current.trim());
			current = '';
		} else {
			current += char;
		}
	});
	if (current.trim()) stops.push(current.trim());

	return stops;
};

export const getGradientCss = (gradient: SiteBackgroundGradient): string => {
	const allColors: string[] = [];

	gradient.colors.forEach(({ value }) => {
		if (!value) return;

		if (value.startsWith('linear-gradient')) {
			allColors.push(...extractGradientStops(value));
		} else {
			allColors.push(value);
		}
	});

	const gradientColors = allColors.join(', ');

	return `linear-gradient(${gradient.angle}deg, ${gradientColors})`;
};
